import {Color} from "three";
import * as THREE from "three";

export const MATERIAL_PROPS_DB = [

    {
        materialName: "CeilingMat",
        aOIntensity: 0.12,
    },

    {
        materialName: "FloorMat",
        aOIntensity: 0.69,
        roughness: 0.55,
        // toneMapped:true,
    },

    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(255, 255, 255),
                metalness: 0,
                roughness: 0,
                // alphaMap: texture,
                alphaTest: 0.5,
                envMap: envMap, //this.backgroundMap,
                envMapIntensity: .2,
                depthWrite: false,
                transmission: .8, // use material.transmission for glass materials
                opacity: 0.49, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true
            });
        },
    },

    {
        materialName: "VideoButtonBaseMat",

        envMapIntensity: 4.179193713700034,

    },


    {
        materialName: "I_UVT_01",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_02",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_03",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_04",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_05",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_06",
        toneMapped: 'N',
    },
    {
        materialName: "I_UVT_07",
        toneMapped: 'N',
    },

    {
        materialName: "LedgeEmmisiveMat",
        toneMapped: 'N',
    },

    {
        materialName: "WallMat",
        // aOIntensity: 0.872736590365562,
        aOIntensity: 0.2,
        envMapIntensity: 7,
    },


    {
        materialName: "HDRIMaterial",
        toneMapped: 'N',
    },

    {
        materialName: "LedgeMat",
        envMapIntensity: 5.0,
        aOIntensity: 0.4,
    },


    {
        materialName: "Door_material",
        envMapIntensity: 2.95671587321773,

        roughness: 0.18822086411686528,
    },


    {
        materialName: "Handle_material",
        envMapIntensity: 3,
        roughness: 0.19,
    },

    {
        materialName:"DFLT_FRAME_MAT_WOOD",
        aOIntensity:0.5485881223516949,

    },

    {
        materialName:"nature_hdri.001",

        toneMapped:"N",
    },

    {
        materialName:"river_hdri",

        toneMapped:"N",
    },


]





